import React, { useState } from 'react';
import { formatCurrency } from '../../utils/currencyFormatter';
import { TicketIcon, PlusIcon, SaveIcon, XIcon, CheckIcon, UserIcon, ClockIcon } from 'lucide-react';
export function OccasionalPasses({
  locale,
  onAddPasses,
  showPassForm,
  setShowPassForm
}) {
  // Mock data for pass balance
  const [passBalance, setPassBalance] = useState({
    currentCount: 42,
    pricePerPass: 25,
    currency: 'USD',
    expiryHours: 12
  });
  // Mock data for pass purchases
  const [purchases, setPurchases] = useState([{
    id: 'purchase-1',
    date: '2023-09-01T10:00:00Z',
    count: 50,
    pricePerPass: 25,
    totalPrice: 1250,
    currency: 'USD',
    purchasedBy: 'John Smith'
  }, {
    id: 'purchase-2',
    date: '2023-10-15T14:30:00Z',
    count: 10,
    pricePerPass: 25,
    totalPrice: 250,
    currency: 'USD',
    purchasedBy: 'Jane Doe'
  }]);
  // Mock data for pass usage
  const [passUsage, setPassUsage] = useState([{
    id: 'pass-1',
    userId: 'user-001',
    userName: 'Michael Johnson',
    startTime: '2023-10-20T09:15:00Z',
    expiryTime: '2023-10-20T21:15:00Z',
    active: false
  }, {
    id: 'pass-2',
    userId: 'user-002',
    userName: 'Sarah Williams',
    startTime: '2023-10-21T10:30:00Z',
    expiryTime: '2023-10-21T22:30:00Z',
    active: false
  }, {
    id: 'pass-3',
    userId: 'user-003',
    userName: 'Robert Brown',
    startTime: '2023-10-22T08:45:00Z',
    expiryTime: '2023-10-22T20:45:00Z',
    active: true
  }]);
  // Form state for purchasing passes
  const [formData, setFormData] = useState({
    count: 10,
    pricePerPass: passBalance.pricePerPass
  });
  // Calculate total price
  const totalPrice = formData.count * formData.pricePerPass;
  // Handle form field changes
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    if (name === 'count') {
      setFormData({
        ...formData,
        count: parseInt(value, 10) || 0
      });
    }
  };
  // Handle price change
  const handlePriceChange = e => {
    const {
      value
    } = e.target;
    // Remove non-numeric characters except decimal point
    const sanitizedValue = value.replace(/[^\d.]/g, '');
    const priceValue = parseFloat(sanitizedValue || '0');
    if (!isNaN(priceValue)) {
      setFormData({
        ...formData,
        pricePerPass: priceValue
      });
    }
  };
  // Handle form submission
  const handleSubmit = e => {
    e.preventDefault();
    // Create new purchase
    const newPurchase = {
      id: `purchase-${new Date().getTime()}`,
      date: new Date().toISOString(),
      count: formData.count,
      pricePerPass: formData.pricePerPass,
      totalPrice: totalPrice,
      currency: passBalance.currency,
      purchasedBy: 'Admin'
    };
    // Update purchases and pass balance
    setPurchases([newPurchase, ...purchases]);
    setPassBalance({
      ...passBalance,
      currentCount: passBalance.currentCount + formData.count
    });
    // Reset form
    setShowPassForm(false);
  };
  return <div className="space-y-8" data-id="element-15756">
      {showPassForm ? <div className="bg-white shadow sm:rounded-lg" data-id="element-15757">
          <div className="px-4 py-5 sm:p-6" data-id="element-15758">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-15759">
              Purchase Occasional Passes
            </h3>
            <form className="mt-5 space-y-6" onSubmit={handleSubmit} data-id="element-15760">
              <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-15761">
                <div className="sm:col-span-3" data-id="element-15762">
                  <label htmlFor="count" className="block text-sm font-medium text-gray-700" data-id="element-15763">
                    Number of Passes
                  </label>
                  <div className="mt-1" data-id="element-15764">
                    <input type="number" name="count" id="count" value={formData.count} onChange={handleChange} min="1" className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" required data-id="element-15765" />
                  </div>
                </div>
                <div className="sm:col-span-3" data-id="element-15766">
                  <label htmlFor="pricePerPass" className="block text-sm font-medium text-gray-700" data-id="element-15767">
                    Price Per Pass
                  </label>
                  <div className="mt-1" data-id="element-15768">
                    <div className="flex rounded-md shadow-sm" data-id="element-15769">
                      <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm" data-id="element-15770">
                        {passBalance.currency}
                      </span>
                      <input type="text" name="pricePerPass" id="pricePerPass" value={formData.pricePerPass} onChange={handlePriceChange} pattern="^\d*(\.\d{0,2})?$" placeholder="0.00" className="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300" required data-id="element-15771" />
                    </div>
                  </div>
                </div>
                <div className="sm:col-span-6" data-id="element-15772">
                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-15773">
                    <div className="flex justify-between" data-id="element-15774">
                      <span className="text-sm font-medium text-gray-500" data-id="element-15775">
                        Total Price:
                      </span>
                      <span className="text-lg font-bold text-gray-900" data-id="element-15776">
                        {formatCurrency(totalPrice, passBalance.currency, locale)}
                      </span>
                    </div>
                    <div className="mt-2 text-xs text-gray-500" data-id="element-15777">
                      Passes expire {passBalance.expiryHours} hours after
                      activation
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end space-x-3" data-id="element-15778">
                <button type="button" onClick={() => setShowPassForm(false)} className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-15779">
                  Cancel
                </button>
                <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-15780">
                  <SaveIcon className="h-4 w-4 mr-2" data-id="element-15781" />
                  Purchase Passes
                </button>
              </div>
            </form>
          </div>
        </div> : <>
          {/* Pass Balance Card */}
          <div className="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200" data-id="element-15782">
            <div className="px-4 py-5 sm:px-6" data-id="element-15783">
              <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-15784">
                Occasional Pass Balance
              </h3>
              <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-15785">
                Current balance and pass information
              </p>
            </div>
            <div className="px-4 py-5 sm:p-6" data-id="element-15786">
              <div className="sm:flex sm:items-center sm:justify-between" data-id="element-15787">
                <div className="flex items-center" data-id="element-15788">
                  <div className="flex-shrink-0 bg-green-100 rounded-md p-3" data-id="element-15789">
                    <TicketIcon className="h-6 w-6 text-green-600" data-id="element-15790" />
                  </div>
                  <div className="ml-5" data-id="element-15791">
                    <h4 className="text-lg font-bold text-gray-900" data-id="element-15792">
                      {passBalance.currentCount} passes
                    </h4>
                    <p className="text-sm text-gray-500" data-id="element-15793">
                      {formatCurrency(passBalance.pricePerPass, passBalance.currency, locale)}{' '}
                      per pass
                    </p>
                  </div>
                </div>
                <div className="mt-5 sm:mt-0" data-id="element-15794">
                  <button type="button" onClick={onAddPasses} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-15795">
                    <PlusIcon className="h-4 w-4 mr-2" data-id="element-15796" />
                    Purchase Passes
                  </button>
                </div>
              </div>
              <div className="mt-5 border-t border-gray-200 pt-5" data-id="element-15797">
                <dl className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2" data-id="element-15798">
                  <div className="sm:col-span-1" data-id="element-15799">
                    <dt className="text-sm font-medium text-gray-500" data-id="element-15800">
                      Pass Validity
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900" data-id="element-15801">
                      {passBalance.expiryHours} hours
                    </dd>
                  </div>
                  <div className="sm:col-span-1" data-id="element-15802">
                    <dt className="text-sm font-medium text-gray-500" data-id="element-15803">
                      Used This Month
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900" data-id="element-15804">
                      {passUsage.length} passes
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-15805">
            {/* Purchases Section */}
            <div className="bg-white shadow sm:rounded-lg" data-id="element-15806">
              <div className="px-4 py-5 sm:px-6" data-id="element-15807">
                <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-15808">
                  Pass Purchases
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-15809">
                  History of pass purchases
                </p>
              </div>
              <div className="border-t border-gray-200" data-id="element-15810">
                <div className="overflow-hidden overflow-x-auto" data-id="element-15811">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-15812">
                    <thead className="bg-gray-50" data-id="element-15813">
                      <tr data-id="element-15814">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15815">
                          Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15816">
                          Passes
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15817">
                          Total
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15818">
                          Purchased By
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-15819">
                      {purchases.map(purchase => <tr key={purchase.id} data-id="element-15820">
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-15821">
                            {new Date(purchase.date).toLocaleDateString(locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-15822">
                            {purchase.count}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-15823">
                            {formatCurrency(purchase.totalPrice, purchase.currency, locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-15824">
                            {purchase.purchasedBy}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                  {purchases.length === 0 && <div className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-15825">
                      No purchase history found.
                    </div>}
                </div>
              </div>
            </div>
            {/* Usage Section */}
            <div className="bg-white shadow sm:rounded-lg" data-id="element-15826">
              <div className="px-4 py-5 sm:px-6" data-id="element-15827">
                <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-15828">
                  Pass Usage
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-15829">
                  Recent pass usage by users
                </p>
              </div>
              <div className="border-t border-gray-200" data-id="element-15830">
                <div className="overflow-hidden overflow-x-auto" data-id="element-15831">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-15832">
                    <thead className="bg-gray-50" data-id="element-15833">
                      <tr data-id="element-15834">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15835">
                          User
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15836">
                          Start Time
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15837">
                          Expiry
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15838">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-15839">
                      {passUsage.map(pass => <tr key={pass.id} data-id="element-15840">
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-15841">
                            <div className="flex items-center" data-id="element-15842">
                              <div className="flex-shrink-0 h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-15843">
                                <UserIcon className="h-5 w-5 text-gray-500" data-id="element-15844" />
                              </div>
                              <div className="ml-4" data-id="element-15845">
                                <div className="text-sm font-medium text-gray-900" data-id="element-15846">
                                  {pass.userName}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-15847">
                            {new Date(pass.startTime).toLocaleString(locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-15848">
                            {new Date(pass.expiryTime).toLocaleString(locale)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-15849">
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${pass.active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-15850">
                              {pass.active ? <>
                                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-15851" />
                                  Active
                                </> : <>
                                  <CheckIcon className="h-3 w-3 mr-1" data-id="element-15852" />
                                  Completed
                                </>}
                            </span>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                  {passUsage.length === 0 && <div className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-15853">
                      No pass usage found.
                    </div>}
                </div>
              </div>
            </div>
          </div>
        </>}
    </div>;
}